import { StringFilter } from "./string-filter";

export class OrdInspectionRequestStatusFilter {
    public name?: StringFilter;
}
